export const SET_JOB_APPLICATIONS = 'SET_JOB_APPLICATIONS';
